import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useGetPostByUidQuery } from "@/store/api/postApi";
import ArrowHorizontal from "@/assets/svg/ArrowHorizontal";
import { styles } from "./stylePostHeader";

const PostHeader: React.FC = () => {
  const navigate = useNavigate();
  const { uid } = useParams<{ uid: string }>();

  const { data: postData } = useGetPostByUidQuery(uid!, { skip: !uid });

  const isCorrectPost = postData?.uid === uid;

  return (
    <Box sx={styles.postWrapper}>
      <IconButton onClick={() => navigate(-1)} sx={styles.backButton}>
        <ArrowHorizontal />
      </IconButton>
      <Typography sx={styles.postTitle}>
        {isCorrectPost
          ? `${postData?.isLongForm ? "Article by" : "Post by"} ${postData?.author?.username ?? ""}`
          : "Loading..."}
      </Typography>
    </Box>
  );
};

export default PostHeader;
